import { render, staticRenderFns } from "./TabRelationHeader.vue?vue&type=template&id=23c83261"
import script from "./TabRelationHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./TabRelationHeader.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports